import { IconSvg, IconSvgProps } from "./icon"

export default function ArrowUp(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M12 18.5V6.5" />
      <path d="M16.5 11.0029L12 6.50285L7.5 11.0029" />
    </IconSvg>
  )
}
